<div class="w-100 d-flex flex-wrap" style="flex: 1">
  <ng-container *ngFor="let recipient of list; let i = index; trackBy: trackByFn">
    <div class="round-container col-auto">
      <button class="rounded-button q-white" style="display: flex;">
        <div (dblclick)="ToggleInputButton($event, i, 'edit');">{{recipient}}</div>
        <div class="times-button q-c-dark-grey col-auto q-pointer" (click)="RemoveItemFromList(i)"><i class="fas fa-times fa-xs"></i></div>
      </button>
      <div class="rounded-button q-white" style="display: none;">
        <input autocomplete="off" class="input-button q-white" type="text" (blur)="ToggleInputButton($event, i, 'view');" (keyup)="ToggleInputButton($event, i, 'view-keyup');" [(ngModel)]="list[i]" [disabled]="disabled"/>
      </div>
    </div>
  </ng-container>
  <div *ngIf="datalist && datalist.length > 0 && !datalistIsEmpty" class="input-container"
       [ngbPopover]="f1"
       placement="bottom-left"
       [autoClose]="'outside'"
       container="body"
       popoverClass="popover-input-list"
       #p1="ngbPopover">
    <input autocomplete="off" (blur)="AddItemToList($event, 'blur')" type="text" [name]="placeholder" class="input-element" [placeholder]="placeholder" (keyup)="AddItemToList($event, 'keyup')" [(ngModel)]="inputValue" [disabled]="disabled"/>


    <ng-template #f1>
      <div class="popover-container">
        <ng-container *ngFor="let contact of datalist">
          <ng-container *ngIf="(contact[propName] | Filter:inputValue :list).length > 0">
            <div [ngClass]="{'contact-linked' : idContact === contact.Id}">
              <p class="q-c-dark-main q-bold m-0">{{contact.Name}}</p>
              <ul style="margin-left:0; padding-left:0;">
                <ng-container *ngFor="let Element of (contact[propName] | Filter:inputValue :list)">
                  <li (click)="p1.close(); AddDataListItemToList(Element.value)" style="padding-left:1rem;padding-right:1rem;">
                    <span>{{Element.key}} : </span><span class="q-bold">{{Element.value}}</span>
                  </li>
                </ng-container>
              </ul>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </ng-template>
  </div>

  <div *ngIf="!datalist || datalist.length === 0 || datalistIsEmpty" class="input-container">
    <input autocomplete="off" (blur)="AddItemToList($event, 'blur')" type="text" [name]="placeholder" class="input-element" [placeholder]="placeholder" (keyup)="AddItemToList($event, 'keyup')" [(ngModel)]="inputValue" />
  </div>
</div>
